<div *ngIf="((!records) || records.length === 0)" class="no-results">
    {{retrieving ? 'Retrieving...' : 'No Results'}}
</div>
<cdk-virtual-scroll-viewport *ngIf="records && records.length > 0" itemSize="200" class="audit-viewport">
    <div *cdkVirtualFor="let item of records" class="audit-item">
        <app-audit-item [change]="item"></app-audit-item>
    </div>
</cdk-virtual-scroll-viewport>